module.exports = __webpack_public_path__ + "static/media/7_Peace of mind_IN.a7ad9b8d.txt";